export const DESKTOP_1920 = 1920;
export const DESKTOP_1440 = 1440;
export const DESKTOP_1366 = 1366;
export const DESKTOP_1280 = 1280;
export const DESKTOP_1200 = 1200;
export const DESKTOP_1050 = 1050;
export const DESKTOP_1024 = 1024;

export const TABLET_992 = 992;
export const TABLET_800 = 800;
export const TABLET_768 = 768;
export const TABLET_740 = 740;
export const TABLET_640 = 640;
export const TABLET_600 = 600;

export const MOBILE_575 = 575;
export const MOBILE_500 = 500;
export const MOBILE_460 = 460;
export const MOBILE_380 = 380;
export const MOBILE_320 = 320;

export const ZINDEX = {
  body: '0',
  layout: '200',
  layer: '400',
  modal: '600',
};
